import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

/**
 * Use regular Tailwind text and shape classes to define the loaders. Use flex to define the loader layout.
 *
 * ```html
 * <div class="flex gap-3">
 *  <zelis-skeleton-loader class="flex-initial rounded-full h-24 w-24"></zelis-skeleton-loader>
 *  <div class="flex-grow flex flex-col gap-2">
 *   <zelis-skeleton-loader class="dls-heading-3-light"></zelis-skeleton-loader>
 *   <zelis-skeleton-loader class="text-sm"></zelis-skeleton-loader>
 *   <zelis-skeleton-loader class="text-sm"></zelis-skeleton-loader>
 *   <zelis-skeleton-loader class="text-sm w-1/2"></zelis-skeleton-loader>
 *  </div>
 * </div>
 * ```
 */
@Component({
  selector: 'zelis-skeleton-loader',
  templateUrl: './skeleton-loader.component.html',
  styleUrls: ['./skeleton-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonLoaderComponent {
  @HostBinding() class = 'zelis-dls';
}
